var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 375 88",
    fill: "none",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_159_1186",
    x: -20.5,
    y: 0,
    width: 415.5,
    height: 99,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_159_1186"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_159_1186",
    result: "shape"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_159_1186)",
    transform: "matrix(1, 0, 0, 1, 0, -11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375 11H325.376L334.64 56.6541L375 21.5865V11Z",
    fill: "#FD5200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.204 52.0226L334.64 56.6541L325.376 11L304.204 52.0226Z",
    fill: "#FF9F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.031 28.203L304.204 52.0226L325.376 11L283.031 28.203Z",
    fill: "#00A9E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.113 11L283.031 28.203L325.376 11H228.113Z",
    fill: "#0084C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375 21.5865L334.64 56.6541L375 69.8872V21.5865Z",
    fill: "#E20000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.64 56.6541L375 99V69.8872L334.64 56.6541Z",
    fill: "#F5005D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.204 52.0226L283.031 28.203L228.113 11H-0.5V88L304.204 52.0226Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.e0b782e40d8f057b26d5b5b8f2f96443.svg";
export { ForwardRef as ReactComponent };